// Componente que muestra cards con métricas de preferencias sexuales
// Agrupa usuarios por combinación de sexo y preferencia sexual

import MegaCard, { MegaCardBody } from '../../../styled-components/Card/MegaCard';
import Skeleton from '../../../styled-components/Skeleton/Skeleton';
import { FiRefreshCw } from 'react-icons/fi';

// Componente individual para cada combinación
function PreferenceCard({ title, count, icon, color }) {
  return (
    <div className="card p-4">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-gray-400 text-sm mb-2">{title}</p>
          <p className={`text-4xl font-bold ${color}`}>
            {count}
          </p>
        </div>
        <div className={`text-5xl ${color}`}>
          {icon}
        </div>
      </div>
    </div>
  );
}

export default function SexualPreferencesCards({ data, isLoading, isError, error, refetch }) {
  const handleRefetch = () => {
    if (refetch) {
      refetch();
    }
  };

  // Configuración de las 6 combinaciones
  const combinations = [
    {
      key: 'hombre_hombres',
      title: 'Hombre → Hombres',
      icon: '👨‍❤️‍👨',
      color: 'text-blue-400',
    },
    {
      key: 'hombre_mujeres',
      title: 'Hombre → Mujeres',
      icon: '👨‍❤️‍👩',
      color: 'text-pink-400',
    },
    {
      key: 'hombre_ambos',
      title: 'Hombre → Ambos',
      icon: '👨‍❤️‍👨',
      color: 'text-purple-400',
    },
    {
      key: 'mujer_hombres',
      title: 'Mujer → Hombres',
      icon: '👩‍❤️‍👨',
      color: 'text-pink-400',
    },
    {
      key: 'mujer_mujeres',
      title: 'Mujer → Mujeres',
      icon: '👩‍❤️‍👩',
      color: 'text-purple-400',
    },
    {
      key: 'mujer_ambos',
      title: 'Mujer → Ambos',
      icon: '👩‍❤️‍👩',
      color: 'text-blue-400',
    },
  ];

  if (isLoading) {
    return (
      <div>
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-6 gap-4 pb-6">
          {[...Array(6)].map((_, i) => (
            <Skeleton key={i} h="120px" r="8px" />
          ))}
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div>
        <div className="text-red-400 text-center py-8">
          <p>Error al cargar las métricas: {error?.message || 'Error desconocido'}</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-6 flex justify-between items-center">
        <h2 className="text-xl font-bold text-white light:text-gray-900">
          Usuarios
        </h2>
        <button
          onClick={handleRefetch}
          disabled={isLoading}
          className="p-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
          title="Refrescar datos"
        >
          <FiRefreshCw size={16} className={isLoading ? 'animate-spin' : ''} />
        </button>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-6 gap-4 pb-6">
        {combinations.map((combo) => (
          <PreferenceCard
            key={combo.key}
            title={combo.title}
            count={data?.[combo.key] || 0}
            icon={combo.icon}
            color={combo.color}
          />
        ))}
      </div>
    </div>
  );
}
